"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var AbstractCard = /*#__PURE__*/function (_window$AbstractViewT) {
    _inherits(AbstractCard, _window$AbstractViewT);

    var _super = _createSuper(AbstractCard);

    function AbstractCard(id, options) {
      var _this;

      _classCallCheck(this, AbstractCard);

      var OPTIONS_DEFAULT = {
        animatedPageEnter: false,
        scrollWatcher: false,
        animatedPageEnter_Vgap: window.Detectizr.device.type == "desktop" ? 80 : 40,
        animatedPageEnter_rootMarginVgapPercent: window.Detectizr.device.type == "desktop" ? 0.6 : 0.3,
        showEase: window.Detectizr.device.type == "desktop" ? window.Sine.easeOut : window.Cubic.easeOut,
        showTime: window.Detectizr.device.type == "desktop" ? 0.42 : 0.55
      };
      options = $.extend(true, OPTIONS_DEFAULT, _.clone(options));
      var OPTIONS_MANDATORY = {
        scrollWatcher: options.animatedPageEnter ? {
          rootMargin: "0px 0px " + -options.animatedPageEnter_Vgap * options.animatedPageEnter_rootMarginVgapPercent + "px 0px"
        } : false
      };
      options = $.extend(true, _.clone(options), OPTIONS_MANDATORY);
      _this = _super.call(this, id, options);

      if (_this.options.animatedPageEnter) {
        window.TweenMax.set(_this.$domElement, {
          pointerEvents: "none",
          autoAlpha: 0
        });
      }

      return _this;
    }

    _createClass(AbstractCard, [{
      key: "onScrollWatcherReady",
      value: function onScrollWatcherReady() {
        if (this.scrollWatcher.isInViewport) {
          this.show(this.autoInstantiated ? true : false);
        }
      }
    }, {
      key: "isInViewport",
      value: function isInViewport() {
        this.show();
      }
    }, {
      key: "show",
      value: function show() {
        var isAnimated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        if (this.options.animatedPageEnter) {
          this.enableScrollWatcher(false);
          var nestedTimeline = new window.TimelineMax({
            paused: true
          });
          nestedTimeline.fromTo(this.$domElement, this.options.showTime, {
            y: this.options.animatedPageEnter_Vgap
          }, {
            clearProps: "y, visibility, opacity",
            force3D: "auto",
            y: 0,
            autoAlpha: 1,
            ease: this.options.showEase
          });
          nestedTimeline.set(this.$domElement, {
            clearProps: "pointerEvents"
          });

          _get(_getPrototypeOf(AbstractCard.prototype), "show", this).call(this, isAnimated, nestedTimeline);
        } else {
          _get(_getPrototypeOf(AbstractCard.prototype), "show", this).call(this, false);
        }
      }
    }, {
      key: "dispose",
      value: function dispose() {
        _get(_getPrototypeOf(AbstractCard.prototype), "dispose", this).call(this);
      }
    }]);

    return AbstractCard;
  }(window.AbstractViewTimeline);

  window.AbstractCard = AbstractCard;
})(window);
